<template style='height: 100%'>
  <aside class="menu menuSelectGraph">
    <div class='has-text-right'><button class="delete" aria-label="delete" v-on:click='close'></button></div>
    <p class="menu-label">
      Gráficas
    </p>
    <ul class="menu-list">
      <li v-for='(v,k) in data' :key='k' v-on:click='selectGraph(k)'><a>{{getNameDem(k)}}</a></li>
    </ul>
  </aside>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('showMenu')
    },
    selectGraph(data){
      this.$emit('selectGraph', data)
    },
    getNameDem(data){
      return data.split('-')[2]
    },
  },
  props: {
    data: Object
  }
}
</script>
<style lang='scss'>
.menuSelectGraph {
  @media screen and (max-width: 768px) {
    width: 100%;
  }
  @media screen and (min-width: 1280px) {
    width: 25%
  }
  height: 100%;
  position: fixed;
  background: white;
  padding: 15px;
  z-index: 65;
  top: 0;
  right: 0;
  overflow: scroll;
  border-radius: 0 0 0 0!important;
  border-left: #dbdbdb solid 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/frpm/components/menuGraphsDemo.vue